import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Flag } from "lucide-react";
import { toast } from "sonner";

const REASONS = [
    { id: "contenu-inapproprie", label: "Contenu inapproprié" },
    { id: "infos-trompeuses", label: "Informations trompeuses / fausses" },
    { id: "spam", label: "Spam / publicité abusive" },
    { id: "autre", label: "Autre" },
];

export default function ReportEventButton({ eventId, variant = "outline", className = "" }) {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState(null);
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        if (!reason) { toast.error("Choisissez une raison"); return; }
        if (reason === "autre" && !comment.trim()) {
            toast.error("Précisez la raison"); return;
        }
        setLoading(true);
        try {
            const r = await api.post(`/events/${eventId}/report`,
                { reason, comment: comment.trim() || null });
            toast.success(r.data?.message || "Merci, votre signalement a été pris en compte.");
            setOpen(false); setReason(null); setComment("");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Erreur");
        }
        setLoading(false);
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button variant={variant} size="sm"
                    className={`rounded-full ${className}`}
                    data-testid={`report-${eventId}-btn`}>
                    <Flag size={14} className="mr-1" />Signaler
                </Button>
            </DialogTrigger>
            <DialogContent className="rounded-3xl max-w-md">
                <DialogHeader>
                    <DialogTitle>Signaler cet événement</DialogTitle>
                    <DialogDescription className="text-xs">
                        Votre signalement reste anonyme et n'empêche pas l'affichage de l'événement. Notre équipe l'examinera.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-2 pt-2">
                    {REASONS.map(r => (
                        <button key={r.id} type="button"
                            onClick={() => setReason(r.id)}
                            data-testid={`report-reason-${r.id}`}
                            className={`w-full text-left px-4 py-3 rounded-2xl border-2 transition ${reason === r.id ? "bg-discover-gradient text-white border-transparent" : "border-border hover:bg-accent"}`}>
                            {r.label}
                        </button>
                    ))}
                    {reason === "autre" && (
                        <Textarea value={comment} onChange={(e) => setComment(e.target.value)}
                            placeholder="Précisez la raison..." rows={3}
                            className="rounded-2xl mt-2" data-testid="report-comment" />
                    )}
                    <Button onClick={submit} disabled={loading || !reason}
                        className="w-full rounded-full bg-discover-gradient text-white mt-2"
                        data-testid="report-submit">
                        {loading ? "Envoi..." : "Envoyer le signalement"}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
